var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIcnClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5596 2.56649C24.1468 1.97937 24.1468 1.02746 23.5596 0.440341C22.9725 -0.14678 22.0206 -0.14678 21.4335 0.440341L12 9.87385L2.56649 0.440341C1.97937 -0.14678 1.02746 -0.14678 0.44034 0.440341C-0.14678 1.02746 -0.14678 1.97937 0.44034 2.56649L9.87384 12L0.44034 21.4335C-0.14678 22.0206 -0.14678 22.9725 0.44034 23.5597C1.02746 24.1468 1.97937 24.1468 2.56649 23.5597L12 14.1262L21.4335 23.5597C22.0206 24.1468 22.9725 24.1468 23.5596 23.5597C24.1468 22.9725 24.1468 22.0206 23.5596 21.4335L14.1261 12L23.5596 2.56649Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnClose);
export default __webpack_public_path__ + "static/media/icn-close.1b78e7fcc99ff826d433c2e383c19ade.svg";
export { ForwardRef as ReactComponent };